// extracted by mini-css-extract-plugin
export default {"html_title":"reportsCharts_html_title__Hhu+B","html_title_inner":"reportsCharts_html_title_inner__qXXa+"};